module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "mon"
  }, [_c('span', {
    staticClass: "mo"
  }, [_vm._v("FEBRUARY")])]), _vm._v(" "), _c('p', {
    staticClass: "ChapTitle",
    attrs: {
      "id": "toc2"
    }
  }, [_c('span', {
    staticClass: "un"
  }, [_c('a', {
    attrs: {
      "id": "link5"
    }
  }), _vm._v("HOLLYWOOD SCARF")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-aut"
  }, [_vm._v("by Venus Perez")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "80%",
      "src": "images/pg17_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/flow.jpg"
    }
  }), _vm._v(" Be glamorous by making this scarf with soft rayon fabrics as we did, or make it in cozy wool to keep you warm all winter. Make sure you pick a lining that you like, because it’s totally reversible.")]), _vm._v(" "), _c('p', {
    staticClass: "aut-head"
  }, [_vm._v("MEET THE DESIGNER")]), _vm._v(" "), _c('p', {
    staticClass: "aut-txt"
  }, [_vm._v("Growing up in a family of women who sew, Venus Perez has followed in their footsteps. She fondly recalls memories of sitting at the dining table watching her mom sew and listening to her hum a tune. Now a mother of three, Venus sees a lot of her mom in herself. “Nothing gives greater joy and a sense of accomplishment than when my girls wear the outfits I make and tell their friends I made them,” says Venus. Crafting is a big part of Venus’s life, and sewing is her greatest passion. As a third-generation sewist, Venus hopes her daughters will carry on that gift. Visit Venus at "), _c('i', [_vm._v("Suburbia Soup")]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "http://suburbia-soup.blogspot.com",
      "target": "_blank"
    }
  }, [_vm._v("suburbia-soup.blogspot.com")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg18_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "fis"
  }, [_c('span', {
    staticClass: "col"
  }, [_vm._v("Finished size:")]), _vm._v(" 70½˝ × 13¼˝ (not including the hood)")]), _vm._v(" "), _c('p', {
    staticClass: "fis"
  }, [_c('span', {
    staticClass: "col"
  }, [_vm._v("Fabrics:")]), _vm._v(" Field Study rayon by Anna Maria Horner and Novella rayon by Valori Wells from Free Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("FABRIC REQUIREMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "ocol"
  }, [_vm._v("•")]), _vm._v(" "), _c('b', [_vm._v("For main fabric:")]), _vm._v(" 1½ yards (40˝-wide fabric) or 1 yard (54˝-wide fabric)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "ocol"
  }, [_vm._v("•")]), _vm._v(" "), _c('b', [_vm._v("For lining and Side Panels 1 and 3:")]), _vm._v(" 1½ yards (40˝-wide fabric) or 1 yard (54˝-wide fabric)")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("CUTTING")])]), _vm._v(" "), _c('p', {
    staticClass: "scut"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15_1.jpg"
    }
  }), _vm._v(" "), _c('i', [_vm._v("Patterns are on "), _c('span', {
    attrs: {
      "href": "#/37_chapter31#pg220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pullout")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ch2"
  }, [_c('i', [_vm._v("From main fabric, cut:")])]), _vm._v(" "), _c('p', {
    staticClass: "ctxt"
  }, [_vm._v("2 using Side Panel 2 pattern piece")]), _vm._v(" "), _c('p', {
    staticClass: "ctxt"
  }, [_vm._v("1 rectangle 4⅜˝ × 18½˝ for top panel")]), _vm._v(" "), _c('p', {
    staticClass: "ctxt"
  }, [_vm._v("2 rectangles 14˝ × 36˝ for scarf")]), _vm._v(" "), _c('p', {
    staticClass: "ch2"
  }, [_c('i', [_vm._v("From lining fabric, cut:")])]), _vm._v(" "), _c('p', {
    staticClass: "ctxt"
  }, [_vm._v("2 using Side Panel 1 pattern piece")]), _vm._v(" "), _c('p', {
    staticClass: "ctxt"
  }, [_vm._v("2 using Side Panel 3 pattern piece")]), _vm._v(" "), _c('p', {
    staticClass: "ctxt"
  }, [_vm._v("2 using Side Panel Lining pattern piece")]), _vm._v(" "), _c('p', {
    staticClass: "ctxt"
  }, [_vm._v("1 rectangle 4⅜˝ × 18½˝ for top lining panel")]), _vm._v(" "), _c('p', {
    staticClass: "ctxt"
  }, [_vm._v("2 rectangles 14˝ × 36˝ for scarf lining")]), _vm._v(" "), _c('p', {
    staticClass: "sew"
  }, [_vm._v("Sewing")]), _vm._v(" "), _c('p', {
    staticClass: "s-txt"
  }, [_c('i', [_vm._v("Seam allowances are ⅜˝ unless otherwise noted.")])]), _vm._v(" "), _c('p', {
    staticClass: "sh2"
  }, [_vm._v("Make the Outer Hood")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("1")]), _vm._v(" With right sides facing and notches matching, stitch side panel 1 to side panel 2 and side panel 2 to side panel 3. Press the seams outward toward side panels 1 and 3. Repeat for the other side of the hood. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("A")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg19_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("2")]), _vm._v(" Topstitch along the seam on side panels 1 and 3. Repeat for the other side of the hood (see "), _c('span', {
    attrs: {
      "href": "#/34_chapter28#link36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Topstitching")]), _vm._v("). "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("B")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg19_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("3")]), _vm._v(" With right sides facing, stitch the top panel to a side of the hood, starting from the raw straight edge and easing around the curve. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("C")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg19_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("4")]), _vm._v(" Repeat for the other side of the hood. Clip along the curves (see "), _c('span', {
    attrs: {
      "href": "#/34_chapter28#link39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clipping and Notching")]), _vm._v("). Trim off the excess fabric from the back of the top panel.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("5")]), _vm._v(" Press the seams inward toward the top panel. Topstitch along the seams on the top panel side. Mark the center of the hood top panel in the back. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("D")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg19_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sh2"
  }, [_vm._v("Make the Hood Lining")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("1")]), _vm._v(" With right sides facing, stitch the side panel lining pieces to the top lining panel. Clip along the curved edges and press the seams inward, toward top lining panel.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("2")]), _vm._v(" Pin outer hood inside hood lining with right sides facing and stitch along the straight raw edge. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("A")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg20_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("3")]), _vm._v(" Turn the hood right side out, press the seam, and topstitch along the straight edge. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("B")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg20_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sh2"
  }, [_vm._v("Make the Scarf")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("1")]), _vm._v(" Place the scarf panel rectangles with right sides facing. Stitch along 1 side of the short straight edge to make a 14˝ × 71¼˝ piece. Repeat for the scarf lining.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("2")]), _vm._v(" With right sides facing, match the center mark on the backside of the hood to the center seam of the scarf. Baste the hood to the scarf ¼˝ from the raw edge. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("C")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg20_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("3")]), _vm._v(" Pin the scarf lining to the scarf with the right sides facing and the hood sandwiched between. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("D")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg20_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("4")]), _vm._v(" Stitch along the raw edges, leaving a 4˝ opening on the side opposite the hood. Trim the corners and turn the hooded scarf right side out.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("5")]), _vm._v(" Press the seams and topstitch ⅛˝ from the scarf edge, closing the opening at the same time.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08ed026c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/12_chapter06.vue
// module id = 78
// module chunks = 0